// extracted by mini-css-extract-plugin
module.exports = {"title":"_2x9EfR_nY3xBeCxMiyh0NP","description":"_2UsENKJh3BNAnROU-HMflx","footer":"_1zEJfFwWO9qmH31QlyL8BZ","button":"_3fCxQ54o10auNnlvMFjILG","danger":"_2B92cc8bemdW981WDBweGC"};